import { uuid } from "utils";
import { ICoursePickup } from "./types";

export const generateReference = (prefix?: "P" | "D" | "PP-I", lenght?: number) =>
  lenght && prefix === "PP-I"
    ? `${prefix}${uuid()?.toUpperCase()}${Date.parse(`${new Date()}`)}`.substring(0, lenght)
    : `${prefix}-${lenght}-${uuid()?.toUpperCase()}${Date.parse(`${new Date()}`)}`;
